let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("keohg")).then(() => parcelRequire('jtwQ5'));